import React from 'react';
import PropTypes from 'prop-types';
import ResumeAttachment
from '../../components/ProfileSearch/ProfileDetails/ResumeAttachment/ResumeAttachment';

const ProfileWorkExperienceSection = ({ profile }) => {

  if (!profile.resume && !profile.workExperience) {
    return null;
  }

  return (
    <section>
      <div className="resume-div">
        {
          profile.resume && (
            <ResumeAttachment link={profile.resume} />
          )
        }
      </div>
      {
        profile.workExperience && (
          <section data-testid="workExperienceSection" className="pre-formatted">
            {profile.workExperience}
          </section>
        )
      }
    </section>
  );
};

export default ProfileWorkExperienceSection;

ProfileWorkExperienceSection.propTypes = {
  profile: PropTypes.shape({
    resume: PropTypes.string,
    workExperience: PropTypes.string
  }).isRequired
};
